module.exports = __webpack_public_path__ + "img/bici-hov.45af5d05.png";